import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import Order from "../../../interfaces/forms/Order";
import Filter from "../../../interfaces/forms/Filter";
import {ItemLoaders} from "../../../core/loaders/ItemLoaders";
import {FormGeneralHelper} from "../../../helpers/FormGeneral";
import {configDefault} from "../../../core/config";
import {REQUEST_STATE} from "../../../helpers/RequestHelper";
import {SystemLanguageCollectionInterface} from "../interfaces/SystemLanguageInterface";
import {SYSTEM_LANGUAGE_ACTIONS} from "../actions";

interface UseSystemLanguageInterface {
    systemLanguageCollection: SystemLanguageCollectionInterface | null;
    state: number;
}

const useSystemLanguage = (filters: Array<Filter> = [], orders: Array<Order> = []): UseSystemLanguageInterface => {
    const dispatch = useDispatch();
    const [responseState, setResponseState] = useState<number>(REQUEST_STATE.IDLE);
    const [systemLanguageCollection, setSystemLanguageCollection] = useState<SystemLanguageCollectionInterface | null>(null);

    useEffect(() => {
        if ((responseState !== REQUEST_STATE.PENDING && responseState !== REQUEST_STATE.ERROR) && !systemLanguageCollection) {
            setResponseState(REQUEST_STATE.PENDING);
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/system_languages', configDefault.PLATFORM_API_PREFIX)),
                SYSTEM_LANGUAGE_ACTIONS.LIST,
                filters,
                orders,
                {
                    onSuccess: (data: SystemLanguageCollectionInterface) => {
                        setSystemLanguageCollection(data);
                        setResponseState(REQUEST_STATE.IDLE)
                    },
                    onError: (error: any) => {
                        setSystemLanguageCollection(null);
                        setResponseState(REQUEST_STATE.ERROR)
                    }
                },
                {propagateDataToCallback: true, dispatchAfterCallback: false}
            );
        }
    }, [dispatch, responseState, systemLanguageCollection, filters, orders]);
    return {
        systemLanguageCollection: systemLanguageCollection,
        state: responseState
    };
};

export default useSystemLanguage;
